import { render, staticRenderFns } from "./AnswerAudio.vue?vue&type=template&id=3eb012f0&scoped=true"
import script from "./AnswerAudio.vue?vue&type=script&lang=js"
export * from "./AnswerAudio.vue?vue&type=script&lang=js"
import style0 from "./AnswerAudio.vue?vue&type=style&index=0&id=3eb012f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb012f0",
  null
  
)

export default component.exports